import { faCartShopping } from '@fortawesome/pro-solid-svg-icons';
import styled from 'styled-components';

import { IconButton } from '@sorare/core/src/atoms/buttons/IconButton';
import { ConditionalWrapper } from '@sorare/core/src/atoms/layout/ConditionalWrapper';
import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { Badge } from '@sorare/core/src/atoms/ui/Badge';
import { NotMobileAppFeature } from '@sorare/core/src/components/BuyableFeature';
import { DialogKey } from '@sorare/core/src/components/navigation/WithDialogs';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { useGenerateDialogPath } from '@sorare/core/src/hooks/navigation/useGenerateDialogPath';

import { PromoChip } from 'atoms/PromoChip';
import { useCart } from 'hooks/useCart';

const Relative = styled(Vertical)`
  position: relative;
`;

const BottomCenter = styled(Vertical)`
  position: absolute;
  bottom: calc(-1 * var(--half-unit));
  right: 50%;
  transform: translateX(50%);
`;

export const NavigationCart = () => {
  const { cartCount, hasLivePromos } = useCart();
  const { sport } = useSportContext();
  const generateDialogPath = useGenerateDialogPath();
  const dialogRoute = generateDialogPath(DialogKey.checkout, sport);

  return (
    <NotMobileAppFeature exceptUS>
      <ConditionalWrapper wrap={hasLivePromos} Wrapper={Relative}>
        <Badge badgeContent={cartCount} overlap="circular" color="grey">
          <IconButton
            size="medium"
            icon={faCartShopping}
            color="transparent"
            to={dialogRoute}
          />
        </Badge>
        {!!hasLivePromos && (
          <BottomCenter>
            <PromoChip />
          </BottomCenter>
        )}
      </ConditionalWrapper>
    </NotMobileAppFeature>
  );
};
